import { AnalyticsService } from '../analytics/AnalyticsService.ts';

// Registration is remembered on the que array itself: tearDownPubwise (or a new prebid bundle)
// replaces the que, which naturally makes the next call register again, while repeated calls
// against the same que don't stack duplicate listeners.
const REGISTERED = Symbol.for('fotoscapes.prebidAnalyticsRegistered');

export function initPrebidAnalytics(analytics: AnalyticsService): void {
  window.pbjs = window.pbjs || { que: [] };
  window.pbjs.que = window.pbjs.que || [];
  const que = window.pbjs.que as any;
  if (que[REGISTERED]) {
    return;
  }
  que[REGISTERED] = true;
  que.push(() => {
    window.pbjs.onEvent('adRenderFailed', (data: any) => {
      analytics.emitPrebidRenderFailedEvent({
        adId: data.adId,
        reason: data.reason,
        message: data.message,
        adUnitCode: data.bid?.adUnitCode ?? '',
        cpm: data.bid?.cpm,
        bidder: data.bid?.bidder,
      });
    });

    window.pbjs.onEvent('adRenderSucceeded', (data: any) => {
      analytics.emitPrebidRenderSucceededEvent({
        adId: data.adId,
        adUnitCode: data.bid?.adUnitCode ?? '',
        cpm: data.bid?.cpm,
        bidder: data.bid?.bidder,
      });
    });

    window.pbjs.onEvent('bidWon', (data: any) => {
      analytics.emitPrebidBidWonEvent({
        adId: data.adId,
        adUnitCode: data.adUnitCode,
        cpm: data.cpm,
        bidder: data.bidder,
        auctionId: data.auctionId,
      });
    });

    window.pbjs.onEvent('auctionEnd', (data: any) => {
      analytics.emitPrebidAuctionEndEvent({
        auctionId: data.auctionId,
        bidsReceivedCount: data.bidsReceived?.length ?? 0,
        bidsTimedOutCount: data.bidsTimedOut?.length ?? 0,
        adUnitCodes: data.adUnitCodes ?? [],
      });
    });
  });
}
